import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import * as React from "react";
import {
  numberWithCommas,
  RupeesToPaise,
} from "../../../utility/commaSeperator";
import { RUPEE_SYMBOL } from "../../../utility/Constants";
import {
  convertDateWithMonthName,
  dateConvert,
} from "../../../utility/dateModifier";
import {
  BeneficiaryEdit,
  Invoice,
  Report,
} from "../../resources/assetsManager";
import {
  BUTTON_BG_COLOR,
  SECONDARY_COLOR,
  WHITE_COLOR,
} from "../../resources/colorsManager";
import { OutlinedButtonStyles } from "../../resources/stylesManager";
import { CustomButton } from "../customButton/CustomButton";
import Pagination from "./pagination/Pagination";
import { HiOutlineEye } from "react-icons/hi";
import ResizeListener from "../../../utility/ResizeListener";
import { modifyBankAccount } from "../../../utility/dataModifier";
import { IoRefreshSharp } from "react-icons/io5";

const CustomTable = ({
  selectedTheme,
  headers,
  data,
  viewMore,
  settlement,
  handlePaginate,
  totalElements,
  totalPages,
  onClickViewLedgerDetails,
  offset,
  isFilterApplied,
  onClickViewCustomer,
  tableStyle,
  onClickViewBeneficiary,
  onClickBeneAccNo,
  isTableDataError,
}) => {
  const [indexing, setIndexing] = React.useState(0);
  const { height, width } = ResizeListener();
  React.useEffect(() => {
    setIndexing(0);
  }, [isFilterApplied]);
  return (
    <>
      <TableContainer
        component={Paper}
        style={{
          borderTopLeftRadius: settlement ? "0px" : "20px",
          borderTopRightRadius: settlement ? "0px" : "20px",
          borderBottomLeftRadius: "0px",
          borderBottomRightRadius: "0px",
          backgroundColor: WHITE_COLOR,
          color: settlement ? "black" : "#6F6F6F",
          boxShadow: "none",
          maxHeight: isFilterApplied ? height * 0.5 : height * 0.6,
          minHeight:
            totalPages === 1
              ? isFilterApplied
                ? height * 0.55
                : height * 0.68
              : isFilterApplied
              ? height * 0.25
              : height * 0.35,
          height: isFilterApplied ? height * 0.47 : height * 0.57,
          border: "0px",
          ...tableStyle,
        }}
      >
        <Table sx={{ minWidth: 850 }} stickyHeader className="openSans">
          <TableHead>
            <TableRow>
              {headers?.map((header, index) => {
                return (
                  <>
                    {header.key === "ledgerTransactionType" ? (
                      <>
                        <TableCell
                          key={index}
                          align="left"
                          style={{
                            backgroundColor: WHITE_COLOR,
                            color: settlement ? "black" : "#6F6F6F",
                            border: "0px",
                            borderBottom: "1px solid rgba(196, 196, 196 , 1)",
                            fontWeight: "normal",
                            paddingBottom: "25px",
                            fontSize: "15px",
                            paddingLeft: "25px",
                            minWidth: 120,
                          }}
                        >
                          <span
                            style={{ margin: 0, opacity: 0.6 }}
                            className="openSans"
                          >
                            {header.title}
                          </span>
                        </TableCell>
                      </>
                    ) : header.key === "ledgerTransactionId" ? (
                      <>
                        <TableCell
                          key={index}
                          align="left"
                          style={{
                            backgroundColor: WHITE_COLOR,
                            color: settlement ? "black" : "#6F6F6F",
                            border: "0px",
                            borderBottom: "1px solid rgba(196, 196, 196 , 1)",
                            fontWeight: "normal",
                            paddingBottom: "25px",
                            fontSize: "15px",
                            paddingLeft: "25px",
                            minWidth: 120,
                          }}
                        >
                          <span
                            style={{ margin: 0, opacity: 0.6 }}
                            className="openSans"
                          >
                            {header.title}
                          </span>
                        </TableCell>
                      </>
                    ) : header.key === "ledgerTransactionAmount" ? (
                      <>
                        <TableCell
                          key={index}
                          align="left"
                          style={{
                            backgroundColor: WHITE_COLOR,
                            color: settlement ? "black" : "#6F6F6F",
                            border: "0px",
                            borderBottom: "1px solid rgba(196, 196, 196 , 1)",
                            fontWeight: "normal",
                            paddingBottom: "25px",
                            fontSize: "15px",
                            paddingLeft: "25px",
                            minWidth: 120,
                          }}
                        >
                          <span
                            style={{ margin: 0, opacity: 0.6 }}
                            className="openSans"
                          >
                            {header.title}
                          </span>
                        </TableCell>
                      </>
                    ) : (
                      <TableCell
                        key={index}
                        align="left"
                        style={{
                          backgroundColor: WHITE_COLOR,
                          color: settlement ? "black" : "#6F6F6F",
                          border: "0px",
                          borderBottom: "1px solid rgba(196, 196, 196 , 1)",
                          fontWeight: "normal",
                          paddingBottom: "25px",
                          fontSize: "15px",
                          paddingLeft: "25px",
                        }}
                      >
                        <span
                          style={{ margin: 0, opacity: 0.6 }}
                          className="openSans"
                        >
                          {header.title}
                        </span>
                      </TableCell>
                    )}
                  </>
                );
              })}
            </TableRow>
          </TableHead>

          <TableBody>
            {!isTableDataError && data?.length !== 0 ? (
              data?.map((row, i) => (
                <>
                  <TableRow>
                    {headers.map((header, index) =>
                      header.key === "viewMore" ? (
                        <TableCell
                          align="left"
                          style={{
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            paddingLeft: "25px",
                          }}
                        >
                          <span
                            style={{
                              width: "100px",
                              backgroundColor: SECONDARY_COLOR,
                              padding: "10px 30px",
                              borderRadius: "9px",
                              cursor: "pointer",
                              color: "white",
                            }}
                            className="openSans"
                            onClick={() => {
                              viewMore();
                            }}
                          >
                            View More
                          </span>
                        </TableCell>
                      ) : header.key === "transferTimestamp" ? (
                        <TableCell
                          align="left"
                          style={{
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            width: "100px",
                            paddingLeft: "25px",
                            paddingRight: "0px",
                          }}
                        >
                          <span className="openSans">
                            {row["transferTimestamp"]}
                          </span>
                        </TableCell>
                      ) : header.key === "createdDate" ? (
                        <TableCell
                          style={{
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            minWidth: 150,
                          }}
                        >
                          <span className="openSans">
                            {convertDateWithMonthName(
                              new Date(row["createdDate"])
                            )}
                          </span>
                        </TableCell>
                      ) : header.key === "transferUniqueNo" ? (
                        <TableCell
                          align="left"
                          style={{
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            minWidth: 100,
                          }}
                        >
                          <span
                            style={{
                              wordBreak: "break-all",
                            }}
                          >
                            {row["txnId"]}
                          </span>
                        </TableCell>
                      ) : header.key === "customerTransferUniqueNo" ? (
                        <TableCell
                          align="left"
                          style={{
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            width: "140px",
                            paddingLeft: "25px",
                          }}
                        >
                          <span
                            style={{
                              color: "#3783FB",
                              textDecoration: "underline",
                              wordBreak: "break-all",
                              cursor: "pointer",
                            }}
                            onClick={() => viewMore(row)}
                          >
                            {row["gatewayReferenceId"]}
                          </span>
                        </TableCell>
                      ) : header.key === "transferUniqueNoPayIn" ? (
                        <TableCell
                          align="left"
                          style={{
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            paddingLeft: "25px",
                            minWidth: 120,
                          }}
                        >
                          <span
                            style={{
                              // color: "#3783FB",
                              // textDecoration: "underline",
                              wordBreak: "break-all",
                            }}
                            // onClick={() => viewMore(row)}
                          >
                            {row["transferUniqueNo"]
                              ? row["transferUniqueNo"]
                              : "N/A"}
                          </span>
                        </TableCell>
                      ) : header.key === "ledgerTransactionId" ? (
                        <TableCell
                          align="left"
                          style={{
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            paddingLeft: "25px",
                            color: "black",
                          }}
                        >
                          <span
                            style={{
                              wordBreak: "break-all",
                            }}
                            onClick={() => {
                              // viewMore(row)
                            }}
                          >
                            {row?.txnId ? row?.txnId : "N/A"}
                          </span>
                        </TableCell>
                      ) : header.key === "beneAccountNo" ? (
                        <TableCell
                          align="left"
                          style={{
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            minWidth: 100,
                            color: "black",
                          }}
                        >
                          <span
                            style={{
                              wordBreak: "break-all",
                            }}
                          >
                            {row["beneAccountNo"]}
                          </span>
                        </TableCell>
                      ) : header.key === "customerBeneAccountNo" ? (
                        <TableCell
                          align="left"
                          style={{
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            width: 120,
                            paddingLeft: "25px",
                            color: "black",
                          }}
                        >
                          <span
                            style={{
                              wordBreak: "break-all",
                              cursor: "pointer",
                            }}
                          >
                            {row["customerPaymentDetails"]?.paymentId}
                          </span>
                        </TableCell>
                      ) : header.key === "slno" ? (
                        <TableCell
                          style={{
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                          }}
                        >
                          <span style={{}} className="roboto">
                            {(i + 1) % 10 === 0
                              ? (offset + 1) * 10
                              : parseInt(offset) + 1 &&
                                offset.toString() + (i + 1).toString()}
                          </span>
                        </TableCell>
                      ) : header.key === "export" ? (
                        <TableCell
                          align="left"
                          style={{
                            color: "#6F6F6F",
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            width: "50%",
                            paddingLeft: "25px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              align: "left",
                            }}
                          >
                            <CustomButton
                              icon={Invoice}
                              styles={{
                                ...OutlinedButtonStyles,
                                marginRight: "10px",
                              }}
                              title="Invoice"
                              textStyles={{
                                color: "#3783FB",
                                fontSize: "16px",
                              }}
                            />
                            <CustomButton
                              icon={Report}
                              styles={OutlinedButtonStyles}
                              title="Report"
                              textStyles={{
                                color: "#3783FB",
                                fontSize: "16px",
                              }}
                            />
                          </div>
                        </TableCell>
                      ) : header.key === "action" ? (
                        <TableCell
                          align="left"
                          style={{
                            color: "#6F6F6F",
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            width: "50%",
                            paddingLeft: "25px",
                          }}
                        >
                          <span
                            style={{
                              cursor: "pointer",
                              textDecoration: "underline",
                            }}
                            className="openSans"
                            onClick={() => viewMore()}
                          >
                            See Feature
                          </span>
                          <span style={{}} className="openSans">
                            {" "}
                            /{" "}
                          </span>
                          <span
                            style={{
                              cursor: "pointer",
                              textDecoration: "underline",
                            }}
                            className="openSans"
                            onClick={() => viewMore()}
                          >
                            {" "}
                            Update Feature
                          </span>
                        </TableCell>
                      ) : header.key === "ledgerBeneAccountNo" ? (
                        <TableCell
                          align="left"
                          style={{
                            color: "#6F6F6F",
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            minWidth: 120,
                            paddingLeft: "25px",
                            maxWidth: 200,
                          }}
                        >
                          {" "}
                          <u
                            style={{
                              color: "dodgerblue",
                              cursor: "pointer",
                            }}
                            onClick={() => onClickViewLedgerDetails(row)}
                          >
                            <span
                              style={{
                                wordBreak: "break-all",
                                cursor: "pointer",
                              }}
                            >
                              {row?.transaction?.beneAccountNo}
                            </span>
                          </u>
                        </TableCell>
                      ) : header.key === "ledgerTransactionAmount" ? (
                        <TableCell
                          align="left"
                          style={{
                            color: "#6F6F6F",
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            paddingLeft: "25px",
                          }}
                        >
                          {" "}
                          <span
                            style={{
                              wordBreak: "break-all",
                              cursor: "pointer",
                              color:
                                row?.type === "DEBIT" ? "#F26C6C" : "#25AF4C",
                            }}
                          >
                            {row?.type === "DEBIT" ? "-" : "+"}{" "}
                            {RUPEE_SYMBOL +
                              " " +
                              numberWithCommas(
                                RupeesToPaise(
                                  row?.type === "DEBIT"
                                    ? row?.debit
                                    : row?.credit
                                )
                              )}
                          </span>
                        </TableCell>
                      ) : header.key === "ledgerTransactionType" ? (
                        <TableCell
                          align="left"
                          style={{
                            color: "#6F6F6F",
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            paddingLeft: "25px",
                            width: 180,
                          }}
                        >
                          {" "}
                          <span
                            style={{
                              wordBreak: "break-all",
                              cursor: "pointer",
                              color: "black",
                            }}
                          >
                            {row?.type === "CREDIT" ? "Credit" : "Debit"}
                          </span>
                        </TableCell>
                      ) : header.key === "ledgerFees" ? (
                        <TableCell
                          align="left"
                          style={{
                            color: "#6F6F6F",
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            minWidth: 120,
                            paddingLeft: "25px",
                            maxWidth: 200,
                          }}
                        >
                          {" "}
                          <span
                            style={{
                              wordBreak: "break-all",
                              cursor: "pointer",
                            }}
                          >
                            {row?.transaction?.transferType}
                          </span>
                        </TableCell>
                      ) : header.key === "transferAmt" ? (
                        <TableCell
                          align="left"
                          style={{
                            color: "black",
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            paddingLeft: "25px",
                            whiteSpace: "nowrap",
                            maxWidth: 150,
                          }}
                        >
                          {" "}
                          <span
                            style={{
                              wordBreak: "break-all",
                              cursor: "pointer",
                            }}
                          >
                            {RUPEE_SYMBOL +
                              " " +
                              numberWithCommas(
                                RupeesToPaise(
                                  Number(row?.transferAmt)?.toFixed(2)
                                )
                              )}
                          </span>
                        </TableCell>
                      ) : header.key === "customerTransferAmt" ? (
                        <TableCell
                          align="left"
                          style={{
                            color: "black",
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            paddingLeft: "25px",
                          }}
                        >
                          {" "}
                          <span
                            style={{
                              wordBreak: "break-all",
                              cursor: "pointer",
                            }}
                          >
                            {RUPEE_SYMBOL +
                              " " +
                              numberWithCommas(RupeesToPaise(row?.amount))}
                          </span>
                        </TableCell>
                      ) : header.key === "debit" ? (
                        <TableCell
                          align="left"
                          style={{
                            color: "black",
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            minWidth: 120,
                            paddingLeft: "25px",
                            maxWidth: 200,
                          }}
                        >
                          {" "}
                          <span
                            style={{
                              wordBreak: "break-all",
                              cursor: "pointer",
                            }}
                          >
                            {RUPEE_SYMBOL +
                              " " +
                              numberWithCommas(RupeesToPaise(row?.debit))}
                          </span>
                        </TableCell>
                      ) : header.key === "credit" ? (
                        <TableCell
                          align="left"
                          style={{
                            color: "black",
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            minWidth: 120,
                            paddingLeft: "25px",
                            maxWidth: 200,
                          }}
                        >
                          {" "}
                          <span
                            style={{
                              wordBreak: "break-all",
                              cursor: "pointer",
                            }}
                          >
                            {RUPEE_SYMBOL +
                              " " +
                              numberWithCommas(RupeesToPaise(row?.credit))}
                          </span>
                        </TableCell>
                      ) : header.key === "openingBalance" ? (
                        <TableCell
                          align="left"
                          style={{
                            color: "black",
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            minWidth: 120,
                            paddingLeft: "25px",
                            maxWidth: 200,
                          }}
                        >
                          {" "}
                          <span
                            style={{
                              wordBreak: "break-all",
                              cursor: "pointer",
                            }}
                          >
                            {RUPEE_SYMBOL +
                              " " +
                              numberWithCommas(
                                RupeesToPaise(row?.openingBalance)
                              )}
                          </span>
                        </TableCell>
                      ) : header.key === "closingBalance" ? (
                        <TableCell
                          align="left"
                          style={{
                            color: "black",
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            paddingLeft: "25px",
                            minWidth: 80,
                          }}
                        >
                          {" "}
                          <span
                            style={{
                              wordBreak: "break-all",
                              cursor: "pointer",
                            }}
                          >
                            {row?.type === "CREDIT"
                              ? RUPEE_SYMBOL +
                                " " +
                                numberWithCommas(
                                  RupeesToPaise(
                                    row?.openingBalance + row?.credit
                                  )
                                )
                              : RUPEE_SYMBOL +
                                " " +
                                numberWithCommas(
                                  RupeesToPaise(
                                    row?.openingBalance - row?.debit
                                  )
                                )}
                            {/* {RUPEE_SYMBOL +
                              " " +
                              numberWithCommas(
                                RupeesToPaise(row?.closingBalance)
                              )} */}
                          </span>
                        </TableCell>
                      ) : header.key === "commission" ? (
                        <TableCell
                          align="left"
                          style={{
                            color: "black",
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            paddingLeft: "25px",
                          }}
                        >
                          {" "}
                          <span
                            style={{
                              wordBreak: "break-all",
                              cursor: "pointer",
                            }}
                          >
                            {RUPEE_SYMBOL +
                              " " +
                              numberWithCommas(RupeesToPaise(row?.commission))}
                          </span>
                        </TableCell>
                      ) : header.key === "tax" ? (
                        <TableCell
                          align="left"
                          style={{
                            color: "black",
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            paddingLeft: "25px",
                            minWidth: 80,
                          }}
                        >
                          {" "}
                          <span
                            style={{
                              wordBreak: "break-all",
                              cursor: "pointer",
                            }}
                          >
                            {RUPEE_SYMBOL +
                              " " +
                              numberWithCommas(RupeesToPaise(row?.tax))}
                          </span>
                        </TableCell>
                      ) : header.key === "transferType" ? (
                        <TableCell
                          align="left"
                          style={{
                            color: "black",
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            paddingLeft: "25px",
                            minWidth: 40,
                          }}
                        >
                          {" "}
                          <span
                            style={{
                              wordBreak: "break-all",
                              cursor: "pointer",
                            }}
                          >
                            {row?.transferType}
                          </span>
                        </TableCell>
                      ) : header.key === "customerTransferType" ? (
                        <TableCell
                          align="left"
                          style={{
                            color: "black",
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            paddingLeft: "25px",
                            // width: 100,
                          }}
                        >
                          {" "}
                          <span
                            style={{
                              wordBreak: "break-all",
                              cursor: "pointer",
                            }}
                          >
                            {"UPI"}
                          </span>
                        </TableCell>
                      ) : header.key === "customerName" ? (
                        <TableCell
                          align="left"
                          style={{
                            color: "black",
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            paddingLeft: "25px",
                            // width: 100,
                          }}
                        >
                          {" "}
                          <span
                            style={{
                              wordBreak: "break-all",
                              cursor: "pointer",
                            }}
                          >
                            {row?.firstName + " " + row?.lastName}
                          </span>
                        </TableCell>
                      ) : header.key === "customerMobileNumber" ? (
                        <TableCell
                          align="left"
                          style={{
                            color: "black",
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            paddingLeft: "25px",
                            // width: 100,
                          }}
                        >
                          {" "}
                          <span
                            style={{
                              wordBreak: "break-all",
                              cursor: "pointer",
                            }}
                          >
                            {row?.mobileNumber}
                          </span>
                        </TableCell>
                      ) : header.key === "customerVirtualId" ? (
                        <TableCell
                          align="left"
                          style={{
                            color: "black",
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            paddingLeft: "25px",
                            // width: 100,
                          }}
                        >
                          {" "}
                          <span
                            style={{
                              wordBreak: "break-all",
                              cursor: "pointer",
                            }}
                          >
                            {row?.paymentDetails[0]["paymentId"]?.split("@")[0]}
                          </span>
                        </TableCell>
                      ) : header.key === "customerUpiId" ? (
                        <TableCell
                          align="left"
                          style={{
                            color: "black",
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            paddingLeft: "25px",
                            // width: 100,
                          }}
                        >
                          {" "}
                          <span
                            style={{
                              wordBreak: "break-all",
                              cursor: "pointer",
                            }}
                          >
                            {row?.paymentDetails.length === 2
                              ? row?.paymentDetails[0].paymentMode["mode"] ===
                                "UPI"
                                ? row?.paymentDetails[0].paymentId
                                : row?.paymentDetails[1].paymentId
                              : "N/A"}
                          </span>
                        </TableCell>
                      ) : header.key === "customerAction" ? (
                        <TableCell
                          align="left"
                          style={{
                            color: "black",
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            paddingLeft: "25px",
                            // width: 100,
                          }}
                        >
                          {" "}
                          <span
                            style={{
                              wordBreak: "break-all",
                              cursor: "pointer",
                              backgroundColor: BUTTON_BG_COLOR,
                              padding: 0,
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              width: 25,
                              height: 25,
                              borderRadius: 7,
                            }}
                            onClick={() => onClickViewCustomer(row)}
                          >
                            <HiOutlineEye
                              style={{
                                width: 15,
                                height: 15,
                                color: WHITE_COLOR,
                              }}
                            />
                          </span>
                        </TableCell>
                      ) : header.key === "beneficiaryAction" ? (
                        <TableCell
                          align="left"
                          style={{
                            color: "black",
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            paddingLeft: "25px",
                            // width: 100,
                          }}
                        >
                          {" "}
                          <img
                            src={BeneficiaryEdit}
                            style={{
                              width: 25,
                              height: 25,
                              color: WHITE_COLOR,
                              cursor: "pointer",
                            }}
                            title="Pay"
                            onClick={() => onClickViewBeneficiary(row)}
                          />
                        </TableCell>
                      ) : header.key === "beneAccountNumber" ? (
                        <TableCell
                          align="left"
                          style={{
                            color: "black",
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            paddingLeft: "25px",
                            // width: 100,
                          }}
                        >
                          {" "}
                          <span
                            style={{
                              wordBreak: "break-all",
                              cursor: "pointer",
                              color: BUTTON_BG_COLOR,
                            }}
                            onClick={() => onClickBeneAccNo(row)}
                          >
                            {modifyBankAccount(row?.accountNumber)}
                          </span>
                        </TableCell>
                      ) : header.key === "payinStatus" ? (
                        <TableCell
                          style={{
                            color: "black",
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            minWidth: 60,
                          }}
                        >
                          {" "}
                          <span
                            style={{
                              wordBreak: "break-all",
                              cursor: "pointer",
                              fontSize: 13,
                              textTransform: "capitalize",
                            }}
                            onClick={() => onClickBeneAccNo(row)}
                          >
                            {row?.status?.toLowerCase()}
                          </span>
                        </TableCell>
                      ) : header.key === "payInTax" ? (
                        <TableCell
                          style={{
                            minWidth: 50,
                          }}
                        >
                          {" "}
                          <span
                            style={{
                              wordBreak: "break-all",
                              cursor: "pointer",
                              fontSize: 13,
                            }}
                          >
                            {RUPEE_SYMBOL +
                              " " +
                              numberWithCommas(RupeesToPaise(row?.tax / 100))}
                          </span>
                        </TableCell>
                      ) : header.key === "payInTxnId" ? (
                        <TableCell
                          style={{
                            minWidth: 150,
                          }}
                        >
                          {" "}
                          <span
                            style={{
                              wordBreak: "break-all",
                              fontSize: 13,
                            }}
                          >
                            {row?.txnId}
                          </span>
                        </TableCell>
                      ) : header.key === "payInNetAmount" ? (
                        <TableCell
                          style={{
                            color: "black",
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            paddingLeft: "25px",
                            whiteSpace: "nowrap",
                            maxWidth: 150,
                          }}
                        >
                          {" "}
                          <span
                            style={{
                              wordBreak: "break-all",
                              cursor: "pointer",
                              fontSize: 13,
                            }}
                          >
                            {RUPEE_SYMBOL +
                              " " +
                              numberWithCommas(
                                (
                                  Number(row?.transferAmt / 100) -
                                  (Number(row?.tax / 100) +
                                    Number(row?.commission / 100))
                                )?.toFixed(2)
                              )}
                          </span>
                        </TableCell>
                      ) : header.key === "payInCharge" ? (
                        <TableCell style={{}}>
                          {" "}
                          <span
                            style={{
                              color: "black",
                              whiteSpace: "nowrap",
                              maxWidth: 150,
                            }}
                          >
                            {RUPEE_SYMBOL}{" "}
                            {(
                              Number(row?.tax / 100) +
                              Number(row?.commission / 100)
                            )?.toFixed(2)}
                          </span>
                        </TableCell>
                      ) : header.key === "payoutCommission" ? (
                        <TableCell style={{}}>
                          {" "}
                          <span
                            style={{
                              color: "black",
                              whiteSpace: "nowrap",
                              maxWidth: 150,
                            }}
                          >
                            {RUPEE_SYMBOL}{" "}
                            {RupeesToPaise(Number(row?.commission)?.toFixed(2))}
                          </span>
                        </TableCell>
                      ) : header.key === "payinViewMore" ? (
                        <TableCell
                          style={{
                            color: "#6F6F6F",
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            minWidth: 100,
                          }}
                        >
                          <span
                            style={{
                              cursor: "pointer",
                              color: "dodgerblue",
                              textDecoration: "underline",
                            }}
                            onClick={() => {
                              viewMore(row);
                            }}
                          >
                            View More
                          </span>
                        </TableCell>
                      ) : header.key === "vanDescription" ? (
                        <TableCell
                          style={{
                            color: "#6F6F6F",
                            borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                            minWidth: 80,
                            maxWidth: 120,
                          }}
                          title={row?.description}
                        >
                          <span
                            style={{
                              cursor: "pointer",
                            }}
                          >
                            {row?.description
                              ? row?.description.length > 30
                                ? row?.description?.slice(0, 30) + "..."
                                : row?.description
                              : ""}
                          </span>
                        </TableCell>
                      ) : (
                        <>
                          <TableCell
                            align="left"
                            style={{
                              borderBottom: "1px solid rgba(229, 229, 229 , 1)",
                              paddingLeft: "25px",
                            }}
                          >
                            <span className="openSans">{row[header.key]}</span>
                          </TableCell>
                        </>
                      )
                    )}
                  </TableRow>
                </>
              ))
            ) : (
              <></>
            )}
          </TableBody>
        </Table>
        {data?.length === 0 && !isTableDataError && (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              height: 350,
              alignItems: "center",
            }}
          >
            <p
              style={{
                color: "black",
                fontSize: 12,
              }}
            >
              Action Triggered, data will be visible shortly.
            </p>
          </div>
        )}

        {isTableDataError && (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              height: 350,
              alignItems: "center",
            }}
          >
            <p
              style={{
                color: "black",
              }}
            >
              Something went wrong!
            </p>
          </div>
        )}
      </TableContainer>

      <div
        style={{
          height: "10%",
          width: "100%",
          backgroundColor: selectedTheme?.payload?.colors?.PRIMARY_COLOR,
          borderBottomLeftRadius: "20px",
          borderBottomRightRadius: "20px",
        }}
      >
        <Pagination
          style={{
            height: 70,
            width: "100%",
          }}
          className="pagination-bar"
          currentPage={offset + 1}
          totalCount={totalElements}
          pageSize={10}
          onPageChange={(page) => {
            handlePaginate(page - 1);
            setIndexing(page - 1);
          }}
          totalPages={totalPages}
        />
      </div>
    </>
  );
};

export default CustomTable;
